interface ActiveSession {
  id: string;
  agentName: string;
  agentDisplayName?: string;
  status: string;
  lastMessageAt: string;
}

interface ContinueSessionCTAProps {
  activeSession: ActiveSession | null;
  isRecent: boolean;
  onContinue: () => void;
  formatRelativeTime: (dateString: string) => string;
}

export default function ContinueSessionCTA({ activeSession, isRecent, onContinue, formatRelativeTime }: ContinueSessionCTAProps) {
  if (!activeSession) return null;

  return (
    <div data-testid="session-status-indicator" className="flex items-center gap-2 mt-1.5" style={{ fontSize: 13, fontFamily: 'var(--font-body)' }}>
      {isRecent ? (
        <>
          <div data-testid="session-dot-active" className="w-2 h-2 rounded-full animate-pulse" style={{ background: '#10B981' }} />
          <span style={{ color: 'var(--text-secondary)' }}>
            Session active · Last message {formatRelativeTime(activeSession.lastMessageAt)}
          </span>
        </>
      ) : (
        <>
          <div data-testid="session-dot-paused" className="w-2 h-2 rounded-full" style={{ background: 'var(--text-secondary)' }} />
          <span style={{ color: 'var(--text-secondary)' }}>
            Session paused · Started {formatRelativeTime(activeSession.lastMessageAt)}
          </span>
        </>
      )}
      <button
        data-testid="continue-session-link"
        onClick={onContinue}
        className="hover:underline"
        style={{ color: 'var(--primary)', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: 13 }}
      >
        Continue Session →
      </button>
    </div>
  );
}
